<ng-container *ngIf="inputAttribute?.type == 'CHECKBOX'  && inputAttribute?.possibleValues?.length !== 0">
  <mat-expansion-panel (opened)="onRowExpand(true)" (closed)="onRowClosed(false)" [togglePosition]="'before'"
    class="example-item">
    <mat-expansion-panel-header class="column-selection-accordion-item-header">
      <mat-panel-title>
        <div class="accordion-item-title accordion-title" matTooltip="{{inputAttribute?.description}}"
          [matTooltipClass]="{ 'tool-tip': true }">
          {{inputAttribute.label}}
          <mat-icon *ngIf="inputAttribute?.description" class="d-flex font-16 ml-2 align-items-center icon-help" #tooltip="matTooltip" aria-hidden="false"
            aria-label="help" fontIcon="help" matTooltip="{{inputAttribute?.description}}"
            [matTooltipClass]="{ 'tool-tip': true }">help</mat-icon>
        </div>
        <div class="ml-2" *ngIf="checkIfOneSelected(inputAttribute?.possibleValues, 'selected')"> <i
            class="fa fa-check-circle text-success font-13"></i>
        </div>
      </mat-panel-title>
      
      <div *ngIf="inputAttribute.pivot" class="mar-ato">
        <mat-form-field (click)="onReplicationClick($event)">
          <mat-label>Replication Field</mat-label>
          <mat-select [(ngModel)]="inputAttribute.childAttribute[0].value"
            name="{{inputAttribute?.childAttribute[0]?.name}}"
            (ngModelChange)="onSelectValueChanged(inputAttribute?.childAttribute[0], inputAttribute, $event)"
            [required]="inputAttribute.childAttribute[0].required">
            <mat-option *ngFor="let childAttribute of inputAttribute?.childAttribute[0]?.possibleValues"
              [value]="childAttribute?.group"> {{childAttribute?.group}} </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </mat-expansion-panel-header>
    <div class="column-selection-item-body" role="region">
      <table mat-table [dataSource]="inputAttribute?.possibleValues" class="table-01 columns-table">
        <ng-container matColumnDef="schemaName">
          <th mat-header-cell *matHeaderCellDef class="cell-2 ">
            <!--{{(shouldUseFBAInventorySummaryAsParentAPI === 'false' && selectedDatasource.type === 'AMAZONSELLER' && inputAttribute.label === AllListingsReport)?'prevent-click':''}}-->
            <mat-checkbox class="padding-checkbox "
              (change)="onCheckBoxChangeAll($event, inputAttribute)"
              [(ngModel)]="inputAttribute.selected" [ngModelOptions]="{standalone: true}"
              [disabled]="inputAttribute.max !== 0" [indeterminate]="ifInterMediate(inputAttribute?.possibleValues)">
              <!--  [aria-label]="checkboxLabel(inputAttribute.possibleValues)"> [checked]="!ifAllSelected(inputAttribute.possibleValues)" ifAllSelected(inputAttribute.possibleValues)-->
              Column name </mat-checkbox>
          </th>
          <!--{{(shouldUseFBAInventorySummaryAsParentAPI === 'false' && selectedDatasource.type === 'AMAZONSELLER' && inputAttribute.label === AllListingsReport)?'prevent-click':''}}-->
          <td mat-cell *matCellDef="let row">
            <mat-checkbox class="padding-checkbox " (click)="$event.stopPropagation()"
              [aria-label]="checkboxLabel(inputAttribute?.possibleValues, row)" name="{{inputAttribute?.name}}"
              [(ngModel)]="row.selected" (change)="onCheckBoxChanged(inputAttribute, row, $event, true)"
              [ngModelOptions]="{standalone: true}"
              [disabled]="( !(currentSelection[selectionKey(inputAttribute)]?.includes(row.value)) && (inputAttribute.max !== 0 && currentSelection[selectionKey(inputAttribute)]?.length >= inputAttribute?.max ) ) || (row?.canUnselect === false) || ( !(row?.canSelect) || (row?.disabled ||  row?.group?.endsWith('_NA')))">
              <span class="true" *ngIf="inputAttribute?.updateMode == 'UPSERT'"
                matTooltip="{{row.group + ' is mandatory for upsert.'}}">{{row.group}}</span>
              <span class="false" *ngIf="inputAttribute?.updateMode != 'UPSERT'">{{row.group}}</span>
            </mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="aliasName" *ngIf="selectedDatasource?.type === 'GSS'">
          <th mat-header-cell *matHeaderCellDef class="cell-3"> <span>Alias Name</span>
          </th>
          <td mat-cell *matCellDef="let element; let idxc = index">
            <div class="alias-name drop-down-sty w-45" *ngIf="element?.otherInfo"
              (click)="element.selected && element.otherInfo && toggleFocus(inputAttribute, element,idxc,formPointer,'aliasName',attrIndex)">
              <span>{{getDropDownValue(element,'aliasName')}} </span>
              <!-- <span class="material-icons custom-sty"> arrow_drop_down </span> -->
            </div>
            <ng-container *ngIf="!element?.otherInfo ">
              <!-- <mat-form-field appearance="outline" class="form-input w-45 form-input-1"> <mat-label>Alias Name </mat-label> <input matInput   [ngModelOptions]="{standalone: true}" id="aliasName-{{idxc}}-{{attrIndex}}-{{formPointer}}" [(ngModel)]="element.aliasName" (ngModelChange)="alertToUser(inputAttribute, element, 'aliasName')"> </mat-form-field> -->
              <input class="form-control form-control-sm" type="text" placeholder="Alias Name"
                [ngModelOptions]="{standalone: true, updateOn: 'blur'}"
                id="aliasName-{{idxc}}-{{attrIndex}}-{{formPointer}}" [(ngModel)]="element.aliasName"
                (focus)="currentFieldAliasNameOnFocus = $event.target.value"
                (ngModelChange)="alertToUser(inputAttribute, element, fieldTypeEnum?.aliasName)"
                pattern="{{element?.customColumnPattern}}"> </ng-container>
          </td>
        </ng-container>
        <ng-container matColumnDef="userDefinedDataType"
        *ngIf="selectedDatasource.type === 'GSS'">
          <th mat-header-cell *matHeaderCellDef class="cell-4"> Datatype </th>
          <td mat-cell *matCellDef="let element; let idxc = index">
            <div class="drop-down-sty w-45"> <span>{{element.dataType}} </span> </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="possibleDatatypes"
        *ngIf="selectedDatasource.type === 'GSS'">
          <th mat-header-cell *matHeaderCellDef class="cell-3"> Specified Datatype
          </th>
          <td mat-cell *matCellDef="let element; let idxc = index">
            <div class="alias-name drop-down-sty w-45" *ngIf="element.otherInfo"
              (click)="element?.selected && element?.otherInfo && toggleFocus(inputAttribute, element,idxc,formPointer,'userDefinedDataType',attrIndex)">
              <span>{{getDropDownValue(element,'possibleDatatypes')}} </span> <span class="material-icons custom-sty">
                arrow_drop_down </span> </div>
            <ng-container *ngIf="!element.otherInfo">
              <mat-form-field class="custom-select w-45 full-inline">
                <mat-select [disabled]="element.otherInfo"
                  id="userDefinedDataType-{{idxc}}-{{attrIndex}}-{{formPointer}}"
                  [(ngModel)]="element.userDefinedDataType" [ngModelOptions]="{standalone: true}"
                  (ngModelChange)="alertToUser(inputAttribute, element,fieldTypeEnum?.userDefinedDataType)">
                  <mat-option *ngFor="let i of element?.possibleValues; let pointerColumnLevel = index" [value]="i">
                    {{i}} </mat-option>
                </mat-select>
              </mat-form-field>
            </ng-container>
          </td>
        </ng-container>
        <ng-container matColumnDef="unnesting" >
          <th mat-header-cell *matHeaderCellDef class="cell-3"> Unnesting <button
              mat-icon-button class="icon-btn-sm"
              matTooltip="This option determines how nested objects/columns within a table will be handled during loading. You can override the table level defaults by selecting the corresponding option at the column level."
              color="primary"><i class="fas fa-info-circle text-primary"></i></button></th>
          <td mat-cell *matCellDef="let element; let idxc = index">
            <!--*ngIf="(element.type === 'RECORD' || element.type === 'REPEATED') && element.otherInfo"   vvv && !(selectedDatasource.type === 'GSS')-->
            <div class="alias-name drop-down-sty w-45"
              *ngIf=" (element.type === 'RECORD' || element.type === 'REPEATED') && element.otherInfo"
              (click)="toastMessage('Please select the columns to proceed', element) && element.selected && element.otherInfo && toggleFocus(inputAttribute, element,idxc,formPointer,'maxDepthOfNesting',attrIndex)">
              <span>{{getDropDownValue(element,'unnesting')}} </span> <span
                class="material-icons custom-sty"> arrow_drop_down </span> </div>
            <!-- <div class="alias-name drop-down-sty " *ngIf="selectedDatasource.type === 'GSS'" (click)="disabledAlert()" > <span class="text-truncate-config">N.A. </span> <span class="material-icons custom-sty"> arrow_drop_down </span> </div> -->
            <ng-container
              *ngIf="(element.type === 'RECORD' || element.type === 'REPEATED') && !element.otherInfo ">
              <mat-form-field class="custom-select w-45 full-inline">
                <mat-select [disabled]="element?.otherInfo" id="maxDepthOfNesting-{{idxc}}-{{attrIndex}}-{{formPointer}}"
                  [(ngModel)]="element.maxDepthOfNesting" [ngModelOptions]="{standalone: true}"
                  (ngModelChange)="alertToUser(inputAttribute, element,fieldTypeEnum?.maxDepthOfNesting)">
                  <mat-option *ngFor="let i of unnestingValues; let pointerColumnLevel = index" [value]="i.value">
                    {{i.name}} <span *ngIf="pointerColumnLevel === 0">Table level Settings</span>
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </ng-container>
          </td>
        </ng-container> <!-- "element.canUnselect === false"-->
        <ng-container matColumnDef="primaryKey">
          <th mat-header-cell *matHeaderCellDef class="cell-4"> Primary key <button
              mat-icon-button class="icon-btn-sm"
              matTooltip="Select a primary key for the table. If primary key is not selected, Daton will load the data in Append-Only mode by default."
              color="primary"><i class="fas fa-info-circle text-primary"></i></button></th>
          <td mat-cell *matCellDef="let element">
            <mat-checkbox [ngModelOptions]="{standalone: true}"
              [disabled]="(!(element.canUnselect === undefined) && atLeastOneSelected(inputAttribute, element)) || (!element.selected || (element.type === 'RECORD' || element.type === 'REPEATED'))"
              [(ngModel)]="element.primary"
              matTooltip="{{(element.selected && !element.canUnselect)?'Primary key is mandatory for upsert':''}}"
              (click)="!(element.type === 'RECORD' || element.type === 'REPEATED') && !(!(element.canUnselect === undefined) && atLeastOneSelected(inputAttribute, element)) && toastMessage('Please select the columns to proceed', element) &&  alertToUser(inputAttribute, element,fieldTypeEnum?.primary)">
            </mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="enableHashing" *ngIf="false">
          <th mat-header-cell *matHeaderCellDef class="cell-4"> Column Hashing <button
              mat-icon-button class="icon-btn-sm"
              matTooltip="Select whether the column should be hashed for data anonymization."
              color="primary"><i class="fas fa-info-circle text-primary"></i></button></th>
          <td mat-cell *matCellDef="let element">
            <mat-checkbox [ngModelOptions]="{standalone: true}"
              [(ngModel)]="element.enableHashing"
              [disabled]="!(isDataTypeColumnHashingcompatible(element) && element.selected)"
              matTooltip="{{!(isDataTypeColumnHashingcompatible(element))?'Column Hashing is available only for string and varchar data types.':''}}"
              (change)="onEnableHashingCheckBoxChanged(inputAttribute, element)"
              (click)="!element.selected ? toastMessage('Please select the columns to proceed', element) : true">
            </mat-checkbox>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedSchemaColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedSchemaColumns; let idx = index"
          class="{{ (row.selected)? 'selected-field reverse-bgcolor':''}}"> </tr>
      </table>
      </div>
  </mat-expansion-panel>
</ng-container>